import { IGuestEVisitor } from 'modules/_common/models';
import API from 'services/api';

export const getCalculationGuests = (calculationId: string): Promise<IGuestEVisitor[]> =>
  API.get(`/api/accommodation/calculations/${calculationId}/guests`).then(
    response => response?.data,
  );
